<div mat-dialog-content class="modal-container">
  <div class="modal-header">
    <button
      *ngIf="step === 3"
      type="button"
      class="back-arrow"
      (click)="step = 2"
    >
      <i class="fa-solid fa-arrow-left"></i>
    </button>

    <button (click)="dialogRef.close()" type="button" class="close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <ng-container *ngIf="step === 0">
    <div class="text-center" style="margin-bottom: 20px">
      <h2 translate>components.loginModalComponent.conectarInviertis</h2>
    </div>

    <div class="content-modal">
      <button
        id="btn_login_google"
        (click)="googleRequest.requestAccessToken()"
        class="btn-sign-in"
      >
        <i class="fab fa-google"></i>
        <span translate>components.loginModalComponent.conectarGoogle</span>
      </button>
      <button
        id="btn_login_facebook"
        (click)="loginAppFacebook()"
        class="btn-sign-in"
      >
        <i class="fab fa-facebook"></i>
        <span translate>components.loginModalComponent.conectarFacebook</span>
      </button>
      <button
        id="btn_login_email_option"
        (click)="step = 1"
        class="btn-sign-in"
      >
        <i class="far fa-envelope icon-envelope"></i>
        <span translate>components.loginModalComponent.conectarEmail</span>
      </button>
    </div>

    <div class="text-center" style="margin-top: 20px">
      <p class="text-thin">
        {{ "components.loginModalComponent.sinCuentaPregunta" | translate }}
        <a translate (click)="openSignInModal()"
          >components.loginModalComponent.registrate</a
        >
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 1">
    <div class="text-center" style="margin-bottom: 20px">
      <h2 translate>components.loginModalComponent.conectarEmailLabel</h2>
    </div>

    <form
      (ngSubmit)="login()"
      [formGroup]="loginForm"
      novalidate
      id="form_login_email"
      data-hs-do-not-collect="true"
    >
      <div class="content-modal">
        <div class="input-inv">
          <label for="email" translate
            >components.loginModalComponent.tuEmail</label
          >
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
          />
        </div>
        <div class="input-inv">
          <label for="password" translate
            >components.loginModalComponent.contrasena</label
          >
          <div class="password-container">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              id="password"
              formControlName="password"
            />
            <i
              class="fas"
              [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
              (click)="togglePasswordVisibility()"
            ></i>
          </div>
        </div>
        <button
          type="submit"
          id="btn_login_submit"
          [disabled]="loginForm.invalid || loadingLogin"
          class="submit-btn"
        >
          <ng-container *ngIf="!loadingLogin; else templateName">
            <span translate>components.loginModalComponent.continuar</span>
          </ng-container>
          <ng-template #templateName>
            <i class="fa-solid fa-spinner ms-1 fa-spin fa-2x"></i>
          </ng-template>
        </button>
      </div>
    </form>

    <div class="text-center" style="margin-top: 20px" *ngIf="emailNotFound || wrongPassword">
      <p class="text-thin" *ngIf="emailNotFound">
        {{ "components.loginModalComponent.sinCuentaPregunta" | translate }}
        <a (click)="openSignInModal()" translate
          >components.loginModalComponent.registrate</a
        >
      </p>
      <p class="text-thin" *ngIf="wrongPassword">
        {{ "components.loginModalComponent.olvidasteContrasena" | translate
        }}<a
          [routerLink]="[
            (translateService.currentLang === 'es' ? '/es' : '/en') +
              '/recover-password'
          ]"
          class="text-thin"
          (click)="dialogRef.close()"
          translate
          >components.loginModalComponent.recuperarla</a
        >
      </p>
    </div>
  </ng-container>

  <!-- Step 2: Survey 1 — solo si el usuario es inversor sin perfil -->
  <ng-container *ngIf="step === 2">
    <app-sign-in-step-survey-1
      [surveyObjective]="surveyObjective"
      [surveyRisk]="surveyRisk"
      [surveyInvolvement]="surveyInvolvement"
      (surveyObjectiveChange)="surveyObjective = $event"
      (surveyRiskChange)="surveyRisk = $event"
      (surveyInvolvementChange)="surveyInvolvement = $event"
      (goToStep)="step = 3"
    />
  </ng-container>

  <!-- Step 3: Survey 2 -->
  <ng-container *ngIf="step === 3">
    <app-sign-in-step-survey-2
      [surveyDecision]="surveyDecision"
      [surveyPhrase]="surveyPhrase"
      (surveyDecisionChange)="surveyDecision = $event"
      (surveyPhraseChange)="surveyPhrase = $event"
      (goToStep)="submitInvestorProfile()"
    />
  </ng-container>
</div>
